var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    attrs: {
      "delay": 100,
      "pivotY": 0.3,
      "name": "sizeGuideModal",
      "width": "75%",
      "height": "auto"
    },
    on: {
      "opened": function opened($event) {
        return _vm.processContentModal();
      },
      "closed": _vm.resetContentModal
    }
  }, [_c('section', {
    ref: "sizeGuideContentModal",
    staticClass: "buy-panel-size-guide-modal",
    domProps: {
      "innerHTML": _vm._s(_vm.rawData)
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }